export const VehicleSelection = {
  BY_HSN_TSN: 'BY_HSN_TSN',
  BY_UPLOADING_PHOTO: 'BY_UPLOADING_PHOTO',
  BY_BRAND_MODEL: 'BY_BRAND_MODEL',
} as const;
export type VehicleSelection = (typeof VehicleSelection)[keyof typeof VehicleSelection];
